module.exports = __webpack_public_path__ + "static/media/img_playstore.c11cb274.png";